import { Modal } from 'antd'
import LoginForm from '../components/forms/login-form/login-form'
import { AppConfigProvider, StoreProvider } from '..'

/**
 * Не даем открыть более 1 окна,
 * копим кулбеки в очередь,
 * вызываем все, после авторизации
 */
let modal: { destroy: () => void }
// const queue: (() => void)[] = []

// const handleSuccess = () => {
//   while (queue.length > 0) {
//     const callback = queue.shift() as Function
//     callback()
//   }
//   modal.destroy()
// }

const showLoginModal = (onSuccess: () => void) => {
    // queue.push(onSuccess)

    const handleSuccess = () => {
        modal.destroy()
        onSuccess()
    }

    if (!modal) {
        modal = Modal.info({
            // title: 'Вы вышли из системы или время сессии истекло, выполните вход.',
            content: (
                <StoreProvider>
                    <AppConfigProvider>
                        <LoginForm onSuccess={handleSuccess} />
                    </AppConfigProvider>
                </StoreProvider>
            ),
            closable: false,
            width: 340,
            okButtonProps: { style: { display: 'none' } },
        })
    }
    return modal
}

export default showLoginModal
